import { Theme } from "@outschool/backpack";

export const DEFAULT_LIMIT = 4;
export const DEFAULT_FETCH_POLICY = "cache-and-network";

export enum ClassGroup {
  Enrolled = "enrolled",
  Completed = "completed",
  Waitlisted = "waitlisted",
  Canceled = "canceled",
}

export const getIconButtonBaseStyles = (theme: Theme) => ({
  all: "unset",
  height: 60,
  cursor: "pointer",
  borderRadius: 16,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "background-color 0.1s linear",
  boxShadow: `0px 4px 4px 0px ${theme.palette.primary[50]}`,
  [theme.breakpoints.down("md")]: {
    height: 48,
  },
});

export const getInteractiveStyles = (theme: Theme, selected: boolean) => ({
  backgroundColor: selected
    ? theme.palette.primary[700]
    : theme.palette.primary[50],
  color: selected ? "white" : "black",
  "&:hover, &:focus-visible": {
    backgroundColor: selected
      ? theme.palette.primary[600]
      : theme.palette.primary[100],
  },
});
